import React from "react";

import { Filter, AutocompleteInput, ReferenceInput, BooleanInput, TextInput, SearchInput } from "react-admin";


const commonFilters = [
    (<ReferenceInput source="doctor" reference="doctors" label="Clinician">
            <AutocompleteInput
                optionText={choice => `Clinician ${choice.first_name} ${choice.last_name}`}
            />
        </ReferenceInput>),
    (<ReferenceInput source="station" reference="stations">
            <AutocompleteInput
                optionText={choice => choice.uid}
            />
        </ReferenceInput>),
    (<ReferenceInput source="device" reference="station_devices">
            <AutocompleteInput
                optionText={choice => choice.serial_number}
            />
        </ReferenceInput>)
]


export const ActivationFilter = props => (
    <Filter {...props}>
        {[
            ...commonFilters,
            (<BooleanInput source="status" label='Activation status' />)
        ]}
    </Filter>
);

const MainFilter = props => (
    <Filter {...props}>
        {[
            ...commonFilters,
            (<SearchInput source="q" label="Note" />)
        ]}
    </Filter>
);
export default MainFilter;

